import axios from 'axios';
import { API_URL } from '../constants/api';
import ToastMsg from '../components/common/ToastMsg';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — global error handling
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        if (sessionStorage.getItem('token')) {
          ToastMsg('error', 'Session expired. Please login again.');
          sessionStorage.clear();
          window.location.href = '/';
        }
      } else if (status === 403) {
        ToastMsg('error', 'Permission denied.');
      }
    } else if (error.request) {
      ToastMsg('error', 'Network error. Please check your connection.');
    } else {
      console.error('Error:', error.message);
      ToastMsg('error', 'Unexpected error occurred.');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
